/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Genius_Chip_CustomInputs */

const tr_landing_genius_chip_custom = /** @type {(inputs: Landing_Genius_Chip_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İhtiyacınıza göre`)
};

const en_landing_genius_chip_custom = /** @type {(inputs: Landing_Genius_Chip_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As much as you need`)
};

const de_landing_genius_chip_custom = /** @type {(inputs: Landing_Genius_Chip_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Ihrem Bedarf`)
};

const ru_landing_genius_chip_custom = /** @type {(inputs: Landing_Genius_Chip_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Под ваши задачи`)
};

/**
* | output |
* | --- |
* | "As much as you need" |
*
* @param {Landing_Genius_Chip_CustomInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_genius_chip_custom = /** @type {((inputs?: Landing_Genius_Chip_CustomInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Genius_Chip_CustomInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_genius_chip_custom(inputs)
	if (locale === "de") return de_landing_genius_chip_custom(inputs)
	if (locale === "ru") return ru_landing_genius_chip_custom(inputs)
	return tr_landing_genius_chip_custom(inputs)
});